import { Decimal } from "@syla/shared/decimal";
import { PopulatedWallet } from "@syla/shared/types/models/WalletBase";
import { HoldingsValue } from "../../../../helper/wallet/HoldingsValue";

export function getWalletHoldingsValue({
  holdingsValue,
  walletWithHoldings,
}: {
  holdingsValue: HoldingsValue | undefined;
  walletWithHoldings: { _id: string } & Pick<PopulatedWallet, "holdings">;
}): Decimal | undefined {
  return (
      walletWithHoldings.holdings && walletWithHoldings.holdings.length == 0
    ) ?
      Decimal.from("0")
    : holdingsValue?.getWalletTotals({ walletId: walletWithHoldings._id })
        ?.marketValue;
}
